import { Component, Input, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { ISort } from 'src/app/library/interfaces/filters/sort/sort';
import { FilterService } from 'src/app/library/services/filter/filter.service';

@Component({
    selector: 'filter-sorting',
    templateUrl: './filter-sorting.component.html',
    styleUrls: ['./filter-sorting.component.scss']
})
export class FilterSortingComponent implements OnInit {
    @Input() hideIfEmpty: boolean = false;
    constructor(private filterService: FilterService) {}

    ngOnInit() {}

    public async selectSort(option: ISort) {
        option.direction = option.defaultOrder;
        this.filterService.addSort(option);
        this.filterService.filterChangeEvent();
    }

    get unselectedSorts$() {
        return this.filterService.filterConfig$.pipe(
            map(e => {
                if (e) {
                    return e.sorts?.filter(x => !x.selected);
                }
            })
        );
    }
}
